<div class="container-fluid m-0 p-0" *ngIf="checkDataExist()">
    <div class="card row">
        <div class="card-horizontal">
            <div class="img-square-wrapper">
                <img class="cand-profile-img" src="{{candData.profileImagePath}}"
                    onerror="this.src ='assets/images/stud-image.png';" alt="cand image" crossOrigin='Anonymous'>
            </div>
            <div class="card-body">
                <!-- checkDataExist() -->
                <!-- <p class="card-text"> -->
                <ul>
                    <li>
                        <h4 class="card-title">{{(globals.lang == 'ar')? candData.fullNameAr : candData.fullNameEn}}
                        </h4>
                    </li>
                    <li>
                        <label>{{"CANDUDATE_CODE" | translate | titlecase}}:</label>
                        <label class="label-value">{{candData.candCode }}</label>
                    </li>
                    <li>
                        <label>{{"NATIONAL_ID" | translate | titlecase}}:</label>
                        <label class="label-value">{{ candData.nidNo }}</label>
                    </li>
                    <li>
                        <label>{{"ADDRESS" | translate | titlecase}}:</label>
                        <label class="label-value">{{(globals.lang == 'ar')? candData.addressL1Ar :
                            candData.addressL1En}}</label>
                    </li>
                    <li>
                        <label>{{"GENDER" | translate | titlecase}}:</label>
                        <label class="label-value">{{ candData.gender == "M"? ("MALE" | translate | titlecase) :
                            ("FEMALE" | translate |
                            titlecase) }}</label>
                    </li>
                    <li>
                        <label>{{"EMAIL" | translate | titlecase}}:</label>
                        <label class="label-value">{{ candData.emailAddress1 }}</label>
                    </li>
                    <li class="cand-status"
                        [style.background-color]="candData.appstatusid == 70 ? '#fb8383' : '#0bf50b'">
                        <label>{{"STATUS" | translate | titlecase}}:</label>
                        <label class="label-value">{{(globals.lang == 'ar')? candData.appStatusNameAr :
                            candData.appStatusNameEn}}</label>
                    </li>

                </ul>
                <!-- </p> -->
                <!-- <p class="card-text"></p> -->
            </div>
        </div>
        <!-- <div class="card-footer">
        <small class="text-muted">Last updated 3 mins ago</small>
    </div> -->
    </div>
</div>

<app-loader [show]="!checkDataExist()"></app-loader>